module.exports = __webpack_public_path__ + "img/widget-2.6f09ad62.png";